"use strict"

import CustomFullPagejs from "./CustomFullPagejs";

class Partners {
    constructor() {
        this.isMobile = false;
        this.isDesktop = false;
        this.mobileToDesktop = false;
        this.desktopToMobile = false;
        this.breakpoint = 790;
        this.noResize = false;
        this.partners = document.querySelector('.sl-Partners');
        if (this.partners) {
            this.logos = this.partners.querySelectorAll('ul li a');
            this.texts = this.partners.querySelectorAll('ul li p');
            this.overlay = this.partners.querySelector('.overlay');
            this.leftArrow = this.partners.querySelector('.partners-left-arrow')
            this.rightArrow = this.partners.querySelector('.partners-right-arrow')
            this.activeLogo = this.partners.querySelector('.slick-active a');
            this.activeText = this.partners.querySelector('.slick-active p');
        }
    }
    renderMethodOnLoad() {
        window.innerWidth < this.breakpoint ? this.mobileMethod() : this.desktopMethod()
        window.innerWidth < this.breakpoint ? this.isDesktop = true : this.isMobile = true;
    }
    renderMethodOnResize() {
        window.onresize = () => {
            if (window.innerWidth < this.breakpoint) {
                this.isDesktop = true;
                if (this.isMobile) this.mobileMethod()
                this.isMobile = false;
                this.desktopToMobile = true
            } else {
                this.isMobile = true;
                if (this.isDesktop) this.desktopMethod()
                this.isDesktop = false;
                this.mobileToDesktop = true;
            }
        };
    }
    setDefaultDisplay(index) {
        // set first element display
        this.partners.style.background = `url(${this.logos[index].dataset.bg}) no-repeat center #000`
        this.partners.style.backgroundSize = 'cover'
        this.texts[index].style.opacity = 1;
        for (let i = 0; i < this.texts.length - this.texts.length / 2; i++) this.texts[i].style.top = 0;
        for (let i = 0; i < this.texts.length / 2; i++) this.texts[i + this.texts.length / 2].style.bottom = 0;
        for (let i = 0; i < this.texts.length / 2; i++) this.logos[i + this.texts.length / 2].classList.add('partners-bottom')
    }

    toggleBackGroundDisplay(data) {
        // toggle bg on swipe, click on arrows
        this.overlay.style.opacity = 1;
        setTimeout(() => {
            this.partners.style.background = `url(${data}) no-repeat center #000`;
            this.partners.style.backgroundSize = 'cover'
            setTimeout(() => this.overlay.style.opacity = 0.6, 50)
        }, 50)
    }
    toggleTextsDisplay(text) {
        // toggle text display on hover
        [...this.texts].map(x => x.style.opacity = 0)
        text.style.opacity = 1
    }
    // toggle logo display on hover
    toggleLogosDisplay(logo) {
        [...this.logos].map(x => {
            x.classList.remove('active')
            x.classList.remove('active-p')
            x.classList.remove('active-link')
        });
        logo.classList.add('active')
        logo.classList.add('active-p')
        setTimeout(function () {
            logo.classList.add('active-link')
        }, 400);
    }
    toggleDisplay(x, i) {
        // toggle all element
        this.toggleBackGroundDisplay(x.dataset.bg);
        this.toggleTextsDisplay(this.texts[i]);
        this.toggleLogosDisplay(this.logos[i]);
    }
    logosMouseOver() {
        // toggle all elements on mouse over
        [...this.logos].map((x, i) => x.onmouseover = () => this.toggleDisplay(x, i))
    }


    mobileMethod() {
        const triggerSlick = setInterval(() => {
            if (document.querySelector('.sl-Partners .slick-track')) {
                setTimeout(() => {
                    const partnersTexts = document.querySelectorAll('.partners-slick .slick-slide p');
                    [...partnersTexts].map(x => x.style.position = 'absolute')
                }, 500);
                setTimeout(() => clearInterval(triggerSlick), 1000);
            }
        }, 100)
        this.partners.style.background = `url(${this.logos[0].dataset.bg}) no-repeat center #000`
        this.partners.style.backgroundSize = 'cover'
        this.texts[0].style.opacity = 1;

        $('.sl-Partners ul').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: this.leftArrow,
            nextArrow: this.rightArrow,

        })
        $('.sl-Partners ul').on('swipe', () => this.toggleBackGroundDisplay(this.partners.querySelector('.slick-active a').dataset.bg))
        this.leftArrow.addEventListener('click', () => this.toggleBackGroundDisplay(this.partners.querySelector('.slick-active a').dataset.bg))
        this.rightArrow.addEventListener('click', () => this.toggleBackGroundDisplay(this.partners.querySelector('.slick-active a').dataset.bg))

        var listePartners = document.querySelectorAll('.partners-slick .slick-slide p');
        var that = this;

        for (var i = 0; i < listePartners.length; i++) {
            listePartners[i].maybeTop = false;
            listePartners[i].maybeBottom = false;
            listePartners[i].clientYStart = 0;
            listePartners[i].clientYEnd = 0;

            listePartners[i].addEventListener("touchstart", function (e) {
                this.clientYStart = e.touches[0].clientY;
                if (this.scrollTop == 0) {
                    this.maybeTop = true;

                    if (this.clientHeight + this.scrollTop > this.scrollHeight - 10) {
                        this.maybeBottom = true;
                    }
                }
                else if (this.clientHeight + this.scrollTop > this.scrollHeight - 10) {
                    this.maybeBottom = true;
                }
            });

            listePartners[i].addEventListener("touchend", function (e) {
                e.preventDefault();

                this.clientYEnd = e.changedTouches[0].clientY;
                var sens = 0;

                if (Math.abs(this.clientYStart - this.clientYEnd) > 30) {
                    if (this.clientYEnd > this.clientYStart) {
                        sens = 1;
                    } else if (this.clientYEnd < this.clientYStart) {
                        sens = -1
                    }
                }

                if (this.maybeTop && sens == 1) {
                    fullpage_api.moveSectionUp();
                }
                else if (this.maybeBottom && sens == -1) {
                    fullpage_api.moveSectionDown();
                }

                this.maybeTop = false;
                this.maybeBottom = false;
            });

        }
    }

    desktopMethod() {

        this.partners.style.background = `url(${this.logos[0].dataset.bg}) no-repeat center #000`
        this.partners.style.backgroundSize = 'cover'
        this.texts[0].style.opacity = 1;

        for (let i = 0; i < this.texts.length; i++) {
            const text = this.texts[i];
            text.style.top = '50%';
            text.style.transform = 'translate(0, -50%)'
        }
        this.texts[0].style.top = 0;
        this.texts[0].style.transform = 'translate(0, 0)'
        this.texts[1].style.top = 0;
        this.texts[1].style.transform = 'translate(0, 0)'
        this.texts[this.texts.length - 1].style.top = 'auto';
        this.texts[this.texts.length - 1].style.bottom = 0;
        this.texts[this.texts.length - 1].style.transform = 'translate(0, 0)'
        this.logos[this.texts.length - 1].classList.add('partners-bottom')
        this.texts[this.texts.length - 2].style.top = 'auto';
        this.texts[this.texts.length - 2].style.bottom = 0;
        this.texts[this.texts.length - 2].style.transform = 'translate(0, 0)'
        this.logos[this.texts.length - 2].classList.add('partners-bottom')
        this.texts[this.texts.length - 3].style.top = 'auto';
        this.texts[this.texts.length - 3].style.bottom = '-15vh';
        this.texts[this.texts.length - 3].style.transform = 'translate(0, 0)'
        this.logos[this.texts.length - 3].classList.add('partners-bottom')
        this.logosMouseOver();
        if (this.mobileToDesktop) $('.sl-Partners ul').slick('unslick');

        for (var i = 0; i < this.logos.length; i++) {
            this.logos[i].addEventListener("click", function (e) {
                if (!this.classList.contains("active-link"))
                    e.preventDefault();
            })
        }
    }
    setHover() {
        if (this.partners) {
            this.renderMethodOnLoad()
            if (this.noResize) this.renderMethodOnResize()
        }
    }
}
export default Partners;


// WEBPACK FOOTER //
// ./src/scripts/components/Partners.js